/*
 * Accessibility fix for Debut's Slick carousels (Heavenly Vices, Oct 2026).
 * Slick adds ARIA roles that confuse screen readers:
 *  - product thumbnails: list items get role="option" with no listbox parent,
 *    and the <ul> ends up holding <div>s instead of <li>s
 *  - slideshow dots: <li role="tab"> wraps a <button> (nested controls)
 * This script corrects those attributes after Slick runs and whenever Slick
 * rewrites them. It changes no styling or behaviour.
 */
(function () {
  function fixThumbnails() {
    document.querySelectorAll('.product-single__thumbnails.slick-initialized').forEach(function (ul) {
      if (ul.getAttribute('role') !== 'none') ul.setAttribute('role', 'none');
      ul.querySelectorAll('.slick-track').forEach(function (track) {
        if (track.getAttribute('role') !== 'list') track.setAttribute('role', 'list');
      });
      ul.querySelectorAll('.slick-slide').forEach(function (li) {
        if (li.hasAttribute('role')) li.removeAttribute('role');
        if (li.hasAttribute('aria-selected')) li.removeAttribute('aria-selected');
      });
    });
  }

  function fixDots() {
    document.querySelectorAll('.slick-dots').forEach(function (ul) {
      if (ul.hasAttribute('role')) ul.removeAttribute('role');
      Array.prototype.forEach.call(ul.children, function (li, i) {
        ['role', 'aria-selected', 'aria-controls', 'aria-hidden'].forEach(function (a) {
          if (li.hasAttribute(a)) li.removeAttribute(a);
        });
        var btn = li.querySelector('button');
        if (!btn) return;
        var label = 'Show slide ' + (i + 1);
        if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
        if (btn.hasAttribute('role')) btn.removeAttribute('role');
        var active = li.classList.contains('slick-active');
        if (active && btn.getAttribute('aria-current') !== 'true') btn.setAttribute('aria-current', 'true');
        if (!active && btn.hasAttribute('aria-current')) btn.removeAttribute('aria-current');
      });
    });
  }

  var queued = false;
  function run() {
    queued = false;
    fixThumbnails();
    fixDots();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['role', 'aria-selected', 'aria-hidden', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
